import type { FC } from 'react';
import React from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';

import type { ExtendedTheme } from '@theme/theme';
import type { ActiveDocMeta, NavTree } from '@models/NavigationTree';
import { NavigationSimple } from './components/NavigationSimple/NavigationSimple';
import { NavigationCollapsible } from './components/NavigationCollapsible/NavigationCollapsible';

export interface NavigationProps {
  navTree: NavTree;
  activeDocMeta: ActiveDocMeta;
  resizable: boolean;
}

export const Navigation: FC<Omit<NavigationProps, 'resizable'>> = ({ navTree, activeDocMeta }) => {
  const matches: boolean = useMediaQuery<ExtendedTheme>((theme) => theme.breakpoints.down('lg'));
  const Nav: FC<NavigationProps> = matches ? NavigationCollapsible : NavigationSimple;

  return <Nav activeDocMeta={activeDocMeta} navTree={navTree} resizable={!matches} />;
};
